import R from 'ramda';
import {
  getEmailVerified,
  getAvatar,
  getPhoneNumber,
} from 'ha/modules/ActivationModal/selectors';
import { updateUserData } from 'ha/modules/AuthLogic/actions';

const handleClose = ({ store }) => {
  const state = store.getState();
  const toUpdate = {};

  if (getAvatar(state)) {
    toUpdate.avatarURL = getAvatar(state);
  }
  if (getPhoneNumber(state)) {
    toUpdate.phone = getPhoneNumber(state);
  }
  if (getEmailVerified(state)) {
    toUpdate.isEmailVerified = getEmailVerified(state);
  }
  if (!R.isEmpty(toUpdate)) {
    store.dispatch(updateUserData(toUpdate));
  }
};

export default handleClose;
